import { AlertCircle } from 'react-feather'
import { Button, Modal, ModalBody, Spinner } from 'reactstrap'

const ModalConfirmDelete = ({
  isOpen,
  toggle,
  projectLabel,
  onDelete,
  isLoading,
  errMsg,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    if (onDelete) {
      onDelete()
    }
  }

  return (
    <Modal
      className="p-4"
      centered
      isOpen={isOpen}
      toggle={toggle}
      autoFocus={false}
      data-testid="project-modal-delete"
    >
      <ModalBody>
        <h5>Hapus Project</h5>
        <p className="text-muted">
          Anda yakin ingin menghapus project{' '}
          {projectLabel ? <strong>{projectLabel}</strong> : 'ini'}?
        </p>

        {errMsg && (
          <small className="text-danger">
            <AlertCircle size={15} /> {errMsg}
          </small>
        )}
        <div className="d-flex gap-3">
          <Button
            onClick={toggle}
            disabled={isLoading}
            color="secondary"
            outline
            block
            className="btn-cancel"
            data-testid="project-modal-delete-cancel-button"
          >
            Batal
          </Button>
          <Button
            disabled={isLoading}
            onClick={handleSubmit}
            block
            color="primary"
            data-testid="project-modal-delete-submit-button"
          >
            {isLoading && <Spinner size="sm" className="me-2" />}
            Hapus
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalConfirmDelete
